import { Swiper } from 'swiper';
import { Keyboard, Navigation, Pagination } from 'swiper/modules';

export class InvestorSwiper {
  private instances: Swiper[] = [];

  private findElement(root: ParentNode, selectors: string[]): HTMLElement | null {
    for (const selector of selectors) {
      const element = root.querySelector<HTMLElement>(selector);
      if (element) return element;
    }

    return null;
  }

  constructor() {
    this.init();
  }

  public init(): void {
    const sliders = document.querySelectorAll<HTMLElement>('.swiper-investors');
    if (!sliders.length) return;

    sliders.forEach((sliderElement) => {
      if (sliderElement.classList.contains('swiper-initialized')) return;

      const sliderRoot = sliderElement.closest('.slider-investors') ?? sliderElement.parentElement ?? document;
      const prevEl = this.findElement(sliderRoot, ['.swiper-button-prev', '.content-slide__arrow--prev']);
      const nextEl = this.findElement(sliderRoot, ['.swiper-button-next', '.content-slide__arrow--next']);
      const paginationEl = this.findElement(sliderRoot, ['.swiper-pagination', '.investor-slide__pagination']);

      prevEl?.classList.add('swiper-button-prev');
      nextEl?.classList.add('swiper-button-next');
      paginationEl?.classList.add('swiper-pagination');

      const slider = new Swiper(sliderElement, {
        modules: [Keyboard, Navigation, Pagination],
        centeredSlides: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 40,
        grabCursor: true,
        slideToClickedSlide: true,
        loop: true,
        navigation: prevEl && nextEl ? {
          enabled: true,
          prevEl,
          nextEl,
        } : false,
        pagination: paginationEl ? {
          enabled: true,
          el: paginationEl,
          clickable: true,
        } : false,
        keyboard: {
          enabled: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            centeredSlides: false,
            spaceBetween: 40,
            pagination: {
              enabled: false,
            },
          },
          1024: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 40,
            centeredSlides: false,
          },
        },
      });

      this.instances.push(slider);
    });
  }

  public destroy(): void {
    this.instances.forEach((instance) => {
      if (instance && typeof instance.destroy === 'function') {
        instance.destroy(true, true);
      }
    });

    this.instances = [];
  }
}